/**
 * UI Strings Dictionary
 * 
 * All static UI strings in French (source language)
 * Auto-generated and manually maintained
 */

const dictionary = {
  '__tests__.invalid_credentials': 'Invalid credentials',
  '__tests__.password_must_be': 'Password must be at least 6 characters',
  '__tests__.sign_in_to': 'Sign in to your account',
  'auth.confirmPassword': 'Confirmer le mot de passe',
  'auth.email': 'Email',
  'auth.emailOrUsername': 'Email ou nom d\'utilisateur',
  'auth.enterEmail': 'Entrez votre email',
  'auth.enterPassword': 'Entrez votre mot de passe',
  'auth.enterUsername': 'Entrez votre nom d\'utilisateur',
  'auth.forgotPassword': 'Mot de passe oublié ?',
  'auth.invalidCredentials': 'Identifiants invalides.',
  'auth.login': 'Connexion',
  'auth.loginFailed': 'Connexion échouée',
  'auth.loginSuccess': 'Connexion réussie',
  'auth.loginWith': 'Se connecter avec',
  'auth.logout': 'Déconnexion',
  'auth.networkError': 'Erreur réseau ou serveur injoignable.',
  'auth.newPassword': 'Nouveau mot de passe',
  'auth.or': 'OU',
  'auth.password': 'Mot de passe',
  'auth.rememberMe': 'Se souvenir de moi',
  'auth.resetPassword': 'Réinitialiser le mot de passe',
  'auth.sessionExpired': 'Votre session a expiré.',
  'auth.signup': 'Inscription',
  'auth.signupSuccess': 'Veuillez vérifier votre adresse email.',
  'auth.unknownError': 'Erreur inconnue.',
  'auth.username': 'Nom d\'utilisateur',
  'auth.welcomeMessage': 'Bienvenue sur l\'application !',
  'cards.delete_error': 'Delete error:',
  'cards.delete_replay': 'Delete replay',
  'cards.failed_to_delete': 'Failed to delete replay',
  'cards.poppins_regular': 'Poppins Regular',
  'cards.replay_deleted_successfully': 'Replay deleted successfully',
  'carousel.aucun_stream_en': 'Aucun stream en direct',
  'carousel.il_ny_a': 'Il n\'y a actuellement aucun streamer en ligne.',
  'carousel.revenez_plus_tard': 'Revenez plus tard ou commencez votre propre stream !',
  'cgu.conditions_generales_d': 'Conditions Générales d',
  'chat.noMessages': 'Aucun message',
  'chat.offline': 'Hors ligne',
  'chat.online': 'En ligne',
  'chat.send': 'Envoyer',
  'chat.typeMessage': 'Tapez un message...',
  'common.back': 'Retour',
  'common.cancel': 'Annuler',
  'common.close': 'Fermer',
  'common.confirm': 'Confirmer',
  'common.delete': 'Supprimer',
  'common.donate': 'Faire un Don',
  'common.edit': 'Modifier',
  'common.error': 'Erreur',
  'common.filter': 'Filtrer',
  'common.loading': 'Chargement...',
  'common.next': 'Suivant',
  'common.no': 'Non',
  'common.previous': 'Précédent',
  'common.report': 'Signaler',
  'common.save': 'Enregistrer',
  'common.search': 'Rechercher',
  'common.skip': 'Passer',
  'common.submit': 'Soumettre',
  'common.success': 'Succès',
  'common.total': 'Total',
  'common.yes': 'Oui',
  'tour.header.logo': 'Retournez à l’accueil à tout moment.',
  'tour.header.search': 'Recherchez des contenus, chaînes et jeux ici.',
  'tour.header.theme': 'Changez le thème clair/sombre.',
  'tour.header.language': 'Changez la langue de l’interface.',
  'tour.header.account': 'Accédez à votre compte (connexion/profil).',
  'tour.sidebar.home': 'Accueil : revenez ici quand vous voulez.',
  'tour.sidebar.goLive': 'Passez en direct pour démarrer un stream.',
  'tour.sidebar.events': 'Consultez les événements ici.',
  'tour.sidebar.myEvents': 'Gérez vos événements (visible uniquement connecté).',
  'component.acces_a_tous': 'Accès à tous les streams du jour',
  'component.acces_a_un': 'Accès à un match spécifique',
  'component.acces_au_stream': 'Accès au stream du match',
  'component.acces_complet_a': 'Accès complet à tout l\'',
  'component.acces_gratuit': 'Accès Gratuit',
  'component.acces_illimite': 'Accès illimité',
  'component.achat_en_cours': 'Achat en cours...',
  'component.acheter_un_billet': 'Acheter un billet',
  'component.add_1000_gcoins': 'Acheter des G-Coins',
  'component.administration_complete_de': 'Administration complète de la plateforme',
  'component.assignation_supprimee': 'Assignation supprimée',
  'component.assigner_des_streamers': 'Assigner des streamers',
  'component.bienvenue_sur_corearena': 'Bienvenue sur CoreArena',
  'component.billet_achete_avec': 'Billet acheté avec succès!',
  'component.billet_match': 'Billet Match',
  'component.code_erreur_videojs': 'Code erreur video.js:',
  'component.connexion_reussie_': 'Connexion réussie !',
  'component.crediterdebiter': 'Créditer/débiter',
  'component.creer_evenement': 'Créer Événement',
  'component.creez_et_gerez': 'Créez et gérez vos événements',
  'component.dark_mode': 'Dark Mode',
  'component.duration_multiplier': 'Duration Multiplier:',
  'component.echec_de_connexion': 'Échec de connexion',
  'component.echec_de_l': 'Échec de l\'',
  'component.end_the_game': 'End the game between',
  'component.erreur_de_lecture': 'Erreur de lecture vidéo native',
  'component.erreur_de_validation': 'Erreur de validation',
  'component.erreur_lors_de': 'Erreur lors de l\'',
  'component.erreur_lors_du': 'Erreur lors du chargement du solde',
  'component.erreur_video': 'Erreur vidéo:',
  'component.erreur_videojs': 'Erreur video.js:',
  'component.error_fetching_admin': 'Error fetching admin data:',
  'component.error_fetching_assignments': 'Error fetching assignments:',
  'component.error_fetching_dashboard': 'Error fetching dashboard data:',
  'component.error_fetching_organizer': 'Error fetching organizer data:',
  'component.error_fetching_streamer': 'Error fetching streamer data:',
  'component.error_fetching_streamers': 'Error fetching streamers:',
  'component.error_loading_ticket': 'Error loading ticket data:',
  'component.etesvous_sur_de': 'Êtes-vous sûr de vouloir supprimer cette assignation?',
  'component.evenement': 'Événement',
  'component.failed_to_add': 'Failed to add G-Coins',
  'component.failed_to_load': 'Failed to load balance',
  'component.following_jnoun_is': 'Following jnoun is not implemented yet.',
  'component.format_non_supporte': 'Format non supporté, tentative de fallback...',
  'component.gerer_streamers': 'Gérer Streamers',
  'component.gerer_utilisateurs': 'Gérer Utilisateurs',
  'component.gerez_vos_streams': 'Gérez vos streams et assignations d\'',
  'component.gestion_gcoins': 'Gestion G-Coins',
  'component.label_text': 'Label Text',
  'component.loading_balance': 'Loading balance...',
  'component.manual_recharge_for': 'Recharge du wallet',
  'component.message_erreur_videojs': 'Message erreur video.js:',
  'component.moderation_des_comptes': 'Modération des comptes',
  'component.moderation_et_support': 'Modération et support de la plateforme',
  'component.mot_de_passe': 'Mot de passe',
  'component.no_description_provided': 'Aucune description fournie',
  'component.not_set': 'Not set',
  'component.notes_sur_l': 'Notes sur l',
  'component.nouvel_evenement': 'Nouvel événement',
  'component.parametres_systeme': 'Paramètres système',
  'component.participant_multiplier': 'Participant Multiplier:',
  'component.pass_complet': 'Pass Complet',
  'component.pass_journee': 'Pass Journée',
  'component.performance_de_streaming': 'Performance de streaming',
  'component.poppins_regular': 'Poppins Regular',
  'component.presentez_ce_qr': 'Présentez ce QR code à l\'entrée de l\'événement',
  'component.qr_code_du': 'QR Code du billet',
  'component.role': 'Rôle',
  'component.se_souvenir_de': 'Se souvenir de moi',
  'component.select_player': 'Select player',
  'component.select_this_team': 'Select this Team ?',
  'component.selectionnez_un_billet': 'Sélectionnez un billet',
  'component.service_unavailable': 'Service unavailable',
  'component.single_elimination': 'Single Elimination',
  'component.solde_insuffisant': 'Solde insuffisant',
  'component.something_is_blocking': 'Something is blocking you from accessing our servers.',
  'component.start_the_game': 'Start the game between',
  'component.statistiques_globales': 'Statistiques globales',
  'component.streamer_assigne_avec': 'Streamer assigné avec succès!',
  'component.streamer_de_secours': 'Streamer de Secours',
  'component.tableau_de_bord': 'Tableau de Bord',
  'component.tournament_deleted_succefuly': 'Tournament deleted succefuly',
  'component.tous_les_evenements': 'Tous les événements',
  'component.tous_les_streams': 'Tous les streams',
  'component.types_de_billets': 'Types de billets',
  'component.unfollowing_jnoun_is': 'Unfollowing jnoun is not implemented yet.',
  'component.untitled_event': 'Untitled Event',
  'component.url_de_stream': 'URL de stream invalide',
  'component.veuillez_completer_le': 'Veuillez compléter le reCAPTCHA',
  'component.veuillez_selectionner_un': 'Veuillez sélectionner un type de billet',
  'component.veuillez_vous_connecter': 'Veuillez vous connecter',
  'component.voir_les_gains': 'Voir les gains',
  'component.votre_mot_de': 'Votre mot de passe',
  'component.votre_solde': 'Votre solde:',
  'component.wallet_not_found': 'Wallet not found',
  'component.we_are_experiencing': 'We are experiencing service outages.',
  'component.you_need_to': 'You need to login',
  'component.your_balance': 'Votre solde :',
  'components.default_paragraphe': 'Default paragraphe',
  'components.large_paragraphe': 'Large paragraphe',
  'components.small_paragraphe': 'Small paragraphe',
  'cookie.acceptAll': 'Tout accepter',
  'cookie.analytics': 'Cookies analytiques',
  'cookie.analyticsDesc': 'Ces cookies nous permettent de compter les visites et les sources de trafic afin de mesurer et d\'améliorer les performances de notre site.',
  'cookie.cancel': 'Annuler',
  'cookie.customize': 'Personnaliser',
  'cookie.customizeTitle': 'Personnaliser les cookies',
  'cookie.description': 'Nous utilisons des cookies pour améliorer votre expérience de navigation, analyser le trafic du site et personnaliser le contenu. Vous pouvez choisir d\'accepter tous les cookies, de les refuser ou de personnaliser vos préférences.',
  'cookie.learnMore': 'En savoir plus',
  'cookie.marketing': 'Cookies marketing',
  'cookie.marketingDesc': 'Ces cookies peuvent être définis par nos partenaires publicitaires pour créer un profil de vos intérêts et vous montrer des publicités pertinentes sur d\'autres sites.',
  'cookie.necessary': 'Cookies nécessaires',
  'cookie.necessaryDesc': 'Ces cookies sont essentiels au fonctionnement du site et ne peuvent pas être désactivés. Ils sont généralement définis en réponse à des actions que vous effectuez et qui constituent une demande de services (connexion, formulaires, etc.).',
  'cookie.pageDescription': 'Configurez vos préférences de cookies pour contrôler comment nous collectons et utilisons vos données. Pour en savoir plus sur notre utilisation des cookies et notre politique de confidentialité, consultez notre',
  'cookie.pageTitle': 'Paramètres des cookies',
  'cookie.preferences': 'Cookies de préférences',
  'cookie.preferencesDesc': 'Ces cookies permettent au site de se souvenir de vos choix (comme votre nom d\'utilisateur, votre langue ou la région où vous vous trouvez) et de fournir des fonctionnalités améliorées et plus personnelles.',
  'cookie.preferencesSaved': 'Vos préférences ont été enregistrées avec succès',
  'cookie.privacyPolicy': 'politique de confidentialité',
  'cookie.rejectAll': 'Refuser',
  'cookie.savePreferences': 'Enregistrer mes préférences',
  'cookie.settingsDescription': 'Gérez vos préférences de cookies. Les cookies nécessaires sont toujours activés pour assurer le bon fonctionnement du site.',
  'cookie.title': 'Utilisation des cookies',
  'createevent.describe_your_event': 'Describe your event...',
  'createevent.enter_your_event': 'Enter your event name...',
  'createevent.event_description': 'Event Description',
  'createevent.event_description_is': 'Event description is required and must be at least 10 characters',
  'createevent.event_name_is': 'Event name is required and must be at least 3 characters',
  'createevent.event_settings': 'Event Settings',
  'createevent.failed_to_load': 'Failed to load categories',
  'createevent.failed_to_process': 'Failed to process G-Coins payment',
  'createevent.hide_preview': 'Hide Preview',
  'createevent.leave_empty_for': 'Leave empty for unlimited',
  'createevent.max_participants': 'Max Participants',
  'createevent.network_error': 'Network Error',
  'createevent.network_error_please': 'Network error - please check your connection',
  'createevent.please_login_to': 'Please login to create events',
  'createevent.please_select_an': 'Please select an event category',
  'createevent.step1_choose_category': 'Étape 1 : Choisir une catégorie',
  'createevent.step2_basic_info': 'Étape 2 : Informations',
  'createevent.next_basic_info': 'Suivant : Infos',
  'createevent.next_configuration': 'Suivant : Configuration',
  'createevent.event_name': 'Nom de l\'événement',
  'createevent.creation_fee': 'Frais de création',
  'createevent.creation_fee_title': 'Frais de création de l\'événement',
  'createevent.max_duration': 'Durée max',
  'createevent.unlimited': 'Illimitée',
  'createevent.hours': 'heures',
  'createevent.end_date_auto': 'Date de fin (auto)',
  'createevent.fill_required_fields': 'Veuillez renseigner : Nom, Description, Date de début',
  'createevent.invalid_start_date': 'Date de début invalide',
  'createevent.duration_capped': 'Durée limitée au maximum autorisé.',
  'createevent.max_duration_for': 'Durée max pour',
  'createevent.this_category': 'cette catégorie',
  'createevent.creating': 'Création...',
  'createevent.insufficient_funds': 'Solde insuffisant !',
  'createevent.you_need_more': 'Il vous manque',
  'createevent.more_gcoins': 'G-Coins',
  'createevent.sufficient_funds_publish': 'Vous avez suffisamment de fonds pour publier cet événement !',
  'createevent.step3_configuration': 'Étape 3 : Configuration',
  'createevent.tournament_details': 'Détails du tournoi',
  'createevent.stream_details': 'Détails du stream',
  'createevent.game': 'Jeu',
  'createevent.tags': 'Tags',
  'createevent.search_game_or_random': 'Recherchez un jeu ou choisissez Aléatoire',
  'createevent.random_game_selected': 'Jeu aléatoire sélectionné',
  'createevent.game_input_disabled': 'Saisie du jeu désactivée',
  'createevent.random_game': 'Jeu aléatoire',
  'createevent.clear_random': 'Supprimer aléatoire',
  'createevent.selected': 'Sélectionné',
  'createevent.add_tags_placeholder': 'Ajouter des tags (Entrée)',
  'createevent.streaming_options': 'Options de streaming',
  'createevent.enable_restream': 'Activer le restream',
  'createevent.auto_generate_replay': 'Générer le replay automatiquement',
  'createevent.restream_hint': 'Le restream utilisera les plateformes configurées dans Paramètres → Profil (Facebook, Twitch, YouTube)',
  'createevent.multi_pov': 'Multi-POV (plusieurs streamers / angles)',
  'createevent.chat_mode': 'Mode de chat',
  'createevent.chat_mode_public': 'Public',
  'createevent.chat_mode_subscribers': 'Abonnés uniquement',
  'createevent.chat_mode_disabled': 'Désactivé',
  'createevent.tournament_settings': 'Paramètres du tournoi',
  'createevent.team_size_label': 'Taille d\'équipe (0 = solo)',
  'createevent.team_size_placeholder': '0 = solo, 2 = duo, etc.',
  'createevent.prize_pool_label': 'Prize pool (G-Coins)',
  'createevent.prize_pool_placeholder': 'Prize pool total',
  'createevent.tournament_format': 'Format du tournoi',
  'createevent.format_single_elimination': 'Élimination directe',
  'createevent.format_double_elimination': 'Double élimination',
  'createevent.format_round_robin': 'Round robin',
  'createevent.format_swiss': 'Suisse',
  'createevent.workshop_settings': 'Paramètres du workshop',
  'createevent.max_participants_label': 'Participants max (0 = illimité)',
  'createevent.max_participants_placeholder': 'ex. 30',
  'createevent.ticketing': 'Billetterie',
  'createevent.ticket_type': 'Type de billet',
  'createevent.ticket_price_label': 'Prix (G-Coins, 0 = gratuit)',
  'createevent.ticket_price_placeholder': '0 pour un événement gratuit/public',
  'createevent.ticket_type_full_tournament_pass': 'Pass tournoi complet',
  'createevent.ticket_type_single_ticket': 'Billet unique',
  'createevent.next_manage_participants': 'Suivant : Gérer les participants',
  'createevent.next_go_live': 'Suivant : Passer en direct',
  'createevent.next_dashboard': 'Suivant : Tableau de bord',
  'createevent.step4_manage_tournament_participants': 'Étape 4 : Gérer les participants du tournoi',
  'createevent.invite_streamers': 'Inviter des streamers',
  'createevent.invite_streamers_hint': 'Invitez des streamers à participer et à diffuser leur POV (fonction Multi‑POV).',
  'createevent.invited_user': 'Invité',
  'createevent.invited_players_streamers': 'Joueurs/Streamers invités',
  'createevent.publishing': 'Publication...',
  'createevent.publish_tournament': 'Publier le tournoi',
  'createevent.step4_finish': 'Étape 4 : Terminer',
  'createevent.publish_event': 'Publier l\'événement',
  'createevent.select_event_category': 'Select event category',
  'createtournament.create_new_tournament': 'Create new tournament',
  'createtournament.double_elimination': 'Double Elimination',
  'createtournament.enter_your_tournament': 'Enter your tournament name...',
  'createtournament.error_creating_tournament': 'Error creating tournament',
  'createtournament.network_error': 'Network Error',
  'createtournament.network_error_please': 'Network error - please check your connection',
  'createtournament.please_select_a': 'Please select a game',
  'createtournament.round_robin': 'Round Robin',
  'createtournament.select_a_game': 'Select a game for tournament',
  'createtournament.select_game': 'Select Game',
  'createtournament.single_elimination': 'Single Elimination',
  'createtournament.special_instructions_or': 'Special instructions or attention note for participants...',
  'createtournament.specific_game_mode': 'Specific Game Mode',
  'createtournament.team_participants': 'Team Participants',
  'createtournament.team_participants_number': 'Team Participants number',
  'createtournament.tournament_created_but': 'Tournament created but ID not found',
  'createtournament.tournament_created_successfully': 'Tournament created successfully!',
  'createtournament.tournament_game_title': 'Tournament Game Title',
  'createtournament.tournament_name': 'Tournament name',
  'createtournament.tournament_name_is': 'Tournament name is required and must be at least 3 characters',
  'createtournament.tournament_rules_and': 'Tournament rules and how it works...',
  'createtournament.tournamet_size': 'Tournamet size',
  'createtournament.upload_your_poster': 'upload your poster',
  'error.blocked': 'Quelque chose vous empêche d\'accéder à nos serveurs.',
  'error.channelAlreadyCreated': 'Canal déjà créé.',
  'error.forbidden': 'Accès interdit',
  'error.goHome': 'Retourner à l\'accueil',
  'error.networkError': 'Nous rencontrons des problèmes de service.',
  'error.notFound': 'Page non trouvée',
  'error.serverError': 'Erreur serveur interne',
  'error.tryAgain': 'Veuillez réessayer',
  'error.unauthorized': 'Non autorisé',
  'event.category': 'Catégorie',
  'event.create': 'Créer un Événement',
  'event.description': 'Description',
  'event.details': 'Détails',
  'event.endDate': 'Date de fin',
  'event.join': 'Rejoindre',
  'event.location': 'Lieu',
  'event.management': 'Gestion',
  'event.myEvents': 'Mes Événements',
  'event.startDate': 'Date de début',
  'event.title': 'Événements',
  'eventdetails.event_cancelled': 'Événement annulé',
  'eventdetails.event_ended': 'Événement terminé',
  'eventdetails.event_not_found': 'Événement introuvable',
  'eventdetails.failed_to_load': 'Impossible de charger les détails de l’événement',
  'eventdetails.loading_event_details': 'Chargement des détails de l’événement...',
  'eventdetails.no_participants_yet': 'Aucun participant pour le moment',
  'eventdetails.please_login_to': 'Veuillez vous connecter pour vous inscrire aux événements',
  'eventdetails.registration_failed': 'Échec de l’inscription',
  'eventdetails.rules_information': 'Règles & informations',
  'eventdetails.successfully_unregistered_from': 'Désinscription réussie',
  'eventdetails.ticket_purchased_successfully': 'Ticket acheté avec succès !',
  'eventdetails.tournament_details': 'Détails du tournoi',
  'eventdetails.view_tournament': 'Voir le tournoi',
  'eventdetails.back_to_events': '← Retour aux événements',
  'eventdetails.stream_helper': 'Ceci est un événement de stream en direct. Lorsque l’événement est en direct, vous pouvez le regarder sur la page de stream de l’organisateur.',
  'eventdetails.workshop_helper': 'Ceci est un atelier interactif. Les places peuvent être limitées ; inscrivez-vous tôt pour garantir votre place.',
  'eventdetails.spectators': 'Spectateurs',
  'eventdetails.location': 'Lieu',
  'eventdetails.price': 'Prix',
  'eventdetails.organizer': 'Organisateur',
  'eventdetails.manage_event': 'Gérer l’événement',
  'eventdetails.manage_stream': 'Gérer le stream',
  'eventdetails.open_stream': 'Ouvrir le stream',
  'eventdetails.open_workshop': 'Ouvrir l’atelier',
  'eventdetails.stream_not_live_yet': 'Le stream n’est pas encore en direct',
  'eventdetails.stream_is_live': 'Le stream est en direct.',
  'eventdetails.workshop_is_live': 'L’atelier est en direct.',
  'eventdetails.stream_not_live': 'Le stream n’est pas encore en direct.',
  'eventdetails.workshop_not_live': 'L’atelier n’est pas encore en direct.',
  'eventdetails.get_access': 'Obtenir l’accès',
  'eventdetails.have_ticket_code': 'J’ai un code ticket',
  'eventdetails.access_granted': 'Accès accordé',
  'eventdetails.registered_success': 'Inscription réussie !',
  'eventdetails.paid_event_unregister_disabled': 'C’est un événement payant. L’accès est géré par votre ticket ; la désinscription est désactivée.',
  'eventdetails.unregister': 'Se désinscrire',
  'eventdetails.register_now': 'S’inscrire maintenant',
  'eventdetails.registration_closed': 'Inscriptions fermées',
  'eventdetails.login_to_register': 'Se connecter pour s’inscrire',
  'eventdetails.upcoming_event': 'Événement à venir',
  'eventdetails.event_live': 'Événement en direct',
  'eventdetails.tournament_bracket': 'Tournoi & bracket',
  'eventdetails.bracket_helper': 'Bracket en direct généré depuis les matchs du tournoi. Mise à jour automatique dès que les résultats sont remontés.',
  'eventdetails.live_povs': 'POVs en direct',
  'eventdetails.watch_seamless_pov': 'Regarder (POV seamless)',
  'eventdetails.live_stream': 'Stream en direct',
  'eventdetails.live_workshop': 'Atelier en direct',
  'eventdetails.players_streamers_accepted': 'Joueurs / streamers (acceptés)',
  'eventdetails.no_accepted_players': 'Aucun joueur accepté pour le moment',
  'eventdetails.more_players': 'joueurs en plus',
  'eventdetails.no_spectators_yet': 'Aucun spectateur pour le moment',
  'eventdetails.more_participants': 'participants en plus',
  'eventdetails.redeem_ticket_code': 'Utiliser un code ticket',
  'eventdetails.redeem_ticket_code_help': 'Entrez le code ticket reçu de l’organisateur pour obtenir l’accès à cet événement.',
  'eventdetails.enter_ticket_code': 'Entrez votre code ticket',
  'eventdetails.validating': 'Validation...',
  'eventdetails.redeem_code': 'Valider le code',
  'eventdetails.please_login_redeem': 'Veuillez vous connecter pour utiliser un code ticket',
  'eventdetails.enter_valid_code': 'Veuillez saisir un code valide',
  'eventdetails.ticket_code_redeemed': 'Code ticket utilisé avec succès !',
  'eventdetails.failed_redeem_code': 'Échec de l’utilisation du code',
  'eventmanagement.delete_event': 'Supprimer l’événement',
  'eventmanagement.edit_event_details': 'Modifier les détails de l’événement',
  'eventmanagement.event_not_found': 'Événement introuvable',
  'eventmanagement.event_settings': 'Paramètres de l’événement',
  'eventmanagement.event_settings_and': 'Les paramètres et options de configuration de l’événement seront disponibles ici.',
  'eventmanagement.failed_to_load': 'Impossible de charger les données de l’événement',
  'eventmanagement.failed_to_update': 'Échec de la mise à jour du statut de l’événement',
  'eventmanagement.max_participants': 'Participants max',
  'eventmanagement.no_participants_yet': 'Aucun participant pour le moment',
  'eventmanagement.please_login_to': 'Veuillez vous connecter pour gérer les événements',
  'eventmanagement.share_your_event': 'Partagez votre événement pour obtenir des participants !',
  'eventmanagement.these_actions_cannot': 'Ces actions sont irréversibles.',
  'eventmanagement.ticket_price': 'Prix du ticket',
  'eventmanagement.total_participants': 'Total participants',
  'eventmanagement.you_are_not': 'Vous n’êtes pas autorisé à gérer cet événement',
  'eventmanagement.overview': 'Aperçu',
  'eventmanagement.participants': 'Participants',
  'eventmanagement.streamers': 'Streamers',
  'eventmanagement.settings': 'Paramètres',
  'eventmanagement.loading': 'Chargement de la gestion de l’événement...',
  'eventmanagement.back_to_event': '← Retour à l’événement',
  'eventmanagement.manage_prefix': 'Gérer',
  'eventmanagement.approved': 'Approuvés',
  'eventmanagement.pending': 'En attente',
  'eventmanagement.rejected': 'Rejetés',
  'eventmanagement.quick_actions': 'Actions rapides',
  'eventmanagement.view_public_page': 'Voir la page publique',
  'eventmanagement.publish_event': 'Publier l’événement',
  'eventmanagement.start_event': 'Démarrer l’événement',
  'eventmanagement.end_event': 'Terminer l’événement',
  'eventmanagement.cancel_event': 'Annuler l’événement',
  'eventmanagement.event_information': 'Informations de l’événement',
  'eventmanagement.unlimited': 'Illimité',
  'eventmanagement.not_specified': 'Non spécifié',
  'eventmanagement.all': 'Tous',
  'eventmanagement.registered': 'Inscrit le',
  'eventmanagement.reject': 'Rejeter',
  'eventmanagement.danger_zone': 'Zone dangereuse',
  'eventmanagement.participant_approved': 'Participant approuvé',
  'eventmanagement.participant_rejected': 'Participant rejeté',
  'eventmanagement.failed_to_update_participant_status': 'Échec de la mise à jour du statut du participant',
  'eventmanagement.event_status_updated': 'Statut de l’événement mis à jour',
  'eventmanagement.delete_confirm': 'Supprimer cet événement ? Cette action est irréversible.',
  'eventmanagement.event_deleted': 'Événement supprimé',
  'eventmanagement.failed_to_delete': 'Échec de la suppression de l’événement',

  // Match Details page
  'matchdetails.no_tournament_linked': 'Cet événement n’a aucun tournoi lié',
  'matchdetails.failed_to_load_match': 'Impossible de charger le match',
  'matchdetails.match': 'Match',
  'matchdetails.match_not_found_in_bracket': 'Match introuvable dans le bracket',
  'matchdetails.back_to_event': 'Retour à l’événement',
  'matchdetails.watch_event': 'Regarder l’événement',
  'matchdetails.teams': 'Équipes',
  'matchdetails.need_access_match_pov': 'Vous devez avoir un accès pour regarder les POVs de ce match.',
  'matchdetails.checking': 'Vérification...',
  'matchdetails.no_playback_available': 'Aucun playback disponible.',
  'matchdetails.replay': 'Replay',
  'matchdetails.loading_replays': 'Chargement des replays...',
  'matchdetails.no_replay_linked': 'Aucun replay lié à ce match pour le moment.',
  'matchdetails.watch_replay': 'Regarder le replay',
  'matchdetails.attach_replay_title': 'Associer un replay à ce match',
  'matchdetails.select_event_replay': 'Sélectionner un replay de l’événement...',
  'matchdetails.attaching': 'Association...',
  'matchdetails.attach': 'Associer',
  'matchdetails.replay_attached': 'Replay associé au match',
  'matchdetails.failed_attach_replay': 'Échec de l’association du replay',

  // Tournament Details page
  'tournamentdetails.tab_about': 'À propos',
  'tournamentdetails.tab_summary': 'Résumé',
  'tournamentdetails.tab_rules': 'Règles',
  'tournamentdetails.configuration_error': 'Erreur de configuration',
  'tournamentdetails.tournament_not_found': 'Tournoi introuvable',
  'tournamentdetails.unauthorized_access': 'Accès non autorisé',
  'tournamentdetails.error_loading_tournament': 'Erreur lors du chargement du tournoi',
  'tournamentdetails.attention_title': 'Attention Fortniters',
  'tournamentdetails.welcome_default': 'Bienvenue dans ce tournoi passionnant !',
  'tournamentdetails.how_it_works': 'Comment ça marche',
  'tournamentdetails.rules_announced_soon': 'Les règles du tournoi seront bientôt annoncées.',
  'tournamentdetails.game_mode': 'Mode de jeu',
  'tournamentdetails.single_elimination': 'Élimination directe',
  'tournamentdetails.game': 'Jeu',
  'tournamentdetails.tournament_game': 'Jeu du tournoi',
  'tournamentdetails.prize': 'Récompense',
  'tournamentdetails.prize_tbd': 'Récompense à définir',
  'tournamentdetails.brackets_available_when_started': 'Les brackets seront disponibles une fois le tournoi démarré',
  'tournamentdetails.wait_for_organizer_start': 'Veuillez attendre que l’organisateur démarre le tournoi.',
  'tournamentdetails.tournament_rules': 'Règles du tournoi',
  'tournamentdetails.no_rules_yet': 'Aucune règle n’a encore été définie pour ce tournoi.',
  'tournamentdetails.organizer_updates_rules': 'L’organisateur mettra à jour les règles avant le début du tournoi.',
  'tournamentdetails.joined_success': 'Inscription réussie',
  'tournamentdetails.left_success': 'Vous avez quitté le tournoi',
  'tournamentdetails.join_tournament': 'Rejoindre le tournoi',
  'tournamentdetails.full': 'complet',
  'tournamentdetails.participant': 'Participant',
  'tournamentdetails.pending': 'En attente',
  'tournamentdetails.join': 'Rejoindre',
  'tournamentdetails.leave': 'Quitter',
  'tournamentdetails.leave_confirm_text': 'Êtes-vous sûr de vouloir quitter le tournoi ?',
  'events.failed_to_load': 'Impossible de charger les événements',
  'events.no_events_found': 'Aucun événement trouvé',
  'events.try_adjusting_your': 'Essayez d’ajuster vos filtres ou vos termes de recherche.',
  'faq.questions_frequentes': 'Questions Fréquentes',
  'form.dragDropImage': 'Glissez-déposez une image ou cliquez pour sélectionner',
  'form.invalidEmail': 'Email invalide',
  'form.invalidFormat': 'Format invalide',
  'form.maxLength': 'Longueur maximale :',
  'form.minLength': 'Longueur minimale :',
  'form.passwordMismatch': 'Les mots de passe ne correspondent pas',
  'form.required': 'Ce champ est requis',
  'form.selectOption': 'Sélectionnez une option',
  'form.uploadImage': 'Télécharger une image',
  'game.allGames': 'Tous les Jeux',
  'game.categories': 'Catégories',
  'game.live_channels': 'Canaux en Direct',
  'game.popular': 'Populaires',
  'game.replays': 'Rediffusions',
  'game.tournaments': 'Tournois',
  'game.videos': 'Vidéos',
  'home.aucun_jeu_disponible': 'Aucun jeu disponible',
  'home.aucun_stream_en': 'Aucun stream en direct',
  'home.aucun_tournoi_disponible': 'Aucun tournoi disponible',
  'home.chargement_des_jeux': 'Chargement des jeux...',
  'home.chargement_des_streams': 'Chargement des streams...',
  'home.chargement_des_tournois': 'Chargement des tournois...',
  'home.debug_games': 'Debug Games',
  'home.debug_lives': 'Debug Lives',
  'home.debug_tournaments': 'Debug Tournaments',
  'home.premier_element': 'Premier élément:',
  'home.recent_replays': 'Rediffusions Récentes',
  'home.recommended_games': 'Jeux Recommandés',
  'home.recommended_lives': 'Streams Recommandés',
  'home.recommended_tournaments': 'Tournois Recommandés',
  'howtostream.broadcasting_apps': 'I.I Applications de Diffusion',
  'howtostream.common_tools': 'Voici les outils les plus courants pour la diffusion.',
  'howtostream.controls_instructions': 'Pour configurer vos paramètres, allez dans la section des contrôles (coin inférieur droit), appuyez sur le bouton des paramètres et vous obtiendrez quelque chose comme ceci.',
  'howtostream.download': 'Télécharger',
  'howtostream.download_broadcaster': 'I. Télécharger un diffuseur',
  'howtostream.go_live': 'III.I Prévisualiser votre stream et configurer les scènes',
  'howtostream.go_live_instructions': 'Après avoir configuré le stream, vous pouvez passer en direct en appuyant sur le bouton démarrer le streaming dans le panneau des contrôles (mentionné précédemment).',
  'howtostream.guide': 'Guide',
  'howtostream.how_to_stream': 'Comment streamer?',
  'howtostream.obs_dashboard': 'II.I Tableau de bord Open Broadcaster Software OBS',
  'howtostream.obs_description': 'Nous utiliserons Open Broadcaster Software pour la démonstration.',
  'howtostream.obs_title': 'I.II Open Broadcaster Software OBS',
  'howtostream.preview_instructions': 'Après avoir copié l\'URL du serveur et la clé de stream (depuis le panneau de démarrage du stream sur le site web), réglez le service sur personnalisé puis remplissez les champs avec les données fournies comme indiqué ci-dessus.',
  'howtostream.preview_setup': 'III.I Prévisualiser votre stream et configurer les scènes',
  'howtostream.server_url_instructions': 'Après avoir copié l\'URL du serveur et la clé de stream (depuis le panneau de démarrage du stream sur le site web), réglez le service sur personnalisé puis remplissez les champs avec les données fournies comme indiqué ci-dessus.',
  'howtostream.setup_broadcaster': 'II. Configurer le diffuseur',
  'howtostream.setup_source': 'II.II Configurer la source de streaming',
  'howtostream.start_streaming': 'III. Commencer à streamer',
  'howtostream.ii_setup_brodcaster': 'II. Setup brodcaster',
  'howtostream.iiii_preview_your': 'III.I preview your stream and setup the scenes',
  'howtostream.iiii_setup_streaming': 'II.II setup streaming source',
  'howtostream.obslive_is_streamelements': 'OBS.Live is StreamElements',
  'howtostream.settings_pannel': 'settings pannel',
  'howtostream.streamlabs_obs': 'Streamlabs OBS',
  'howtostream.video_scenes': 'video scenes',
  'layout.conditions_general_dutilisation': 'Conditions Général d\'Utilisation',
  'layout.create_a_tournament': 'Créer un tournoi',
  'layout.log_out': 'Log out',
  'layout.mentions_legales': 'Mentions Légales',
  'layout.my_tournaments': 'Mes Tournois',
  'layout.my_videos': 'Mes vidéos',
  'legal.cgu': 'Conditions Générales d\'Utilisation',
  'legal.faq': 'Questions Fréquentes',
  'legal.mentions': 'Mentions Légales',
  'events.adjust_filters': 'Essayez d\'ajuster vos filtres ou termes de recherche.',
  'events.all': 'Tous',
  'events.be_first_create': 'Soyez le premier à créer un événement!',
  'events.create_event': 'Créer un Événement',
  'events.events': 'Événements',
  'events.loading': 'Chargement des événements...',
  // 'events.no_events_found': 'Aucun événement trouvé', // DUPLICATE - removed (English version at line 281)
  'events.search_events': 'Rechercher des événements...',
  'events.status_cancelled': 'Annulé',
  'events.status_ended': 'Terminé',
  'events.status_live': 'En Direct',
  'events.status_open': 'Ouvert',
  'myevents.browse_events': 'Parcourir les Événements',
  'myevents.create_event': 'Créer un Événement',
  'myevents.create_first_event': 'Créer Votre Premier Événement',
  'myevents.create_first_event_message': 'Commencez à organiser votre premier événement et rassemblez les gens!',
  'myevents.discover_events_message': 'Découvrez et rejoignez des événements passionnants dans votre région!',
  'myevents.joined_events': 'Événements Rejoints',
  'myevents.loading': 'Chargement de vos événements...',
  'myevents.my_events': 'Mes Événements',
  'myevents.no_events_created': 'Aucun événement créé pour le moment',
  'myevents.no_events_joined': 'Aucun événement rejoint pour le moment',
  'myevents.status_cancelled': 'Annulé',
  'myevents.status_draft': 'Brouillon',
  'myevents.status_ended': 'Terminé',
  'myevents.status_live': 'En Direct',
  'myevents.status_published': 'Publié',
  'notfound.back_home': 'Retour à l\'Accueil',
  'notfound.not_found': 'Page Non Trouvée',
  'resetpassword.email_address': 'Adresse e-mail',
  'resetpassword.forgot_password': 'Mot de passe oublié?',
  'resetpassword.reset_password': 'Réinitialiser le mot de passe',
  'resetpassword.use_email_message': 'Veuillez utiliser l\'e-mail que vous utilisez pour vous connecter à Core Arena',
  'newpassword.choose_new_password': 'Choisissez un nouveau mot de passe',
  'newpassword.confirm_button': 'Confirmer le nouveau mot de passe',
  'newpassword.confirm_new_password': 'Confirmer le nouveau mot de passe',
  'newpassword.enter_new_password': 'Entrer le nouveau mot de passe',
  'newpassword.new_password': 'Nouveau mot de passe',
  'mytournaments.archive': 'Archive',
  'mytournaments.create': 'créer',
  'mytournaments.my_tournaments': 'Mes Tournois',
  'tournaments.error_loading': 'Erreur lors du chargement des tournois',
  'tournaments.loading': 'Chargement des tournois...',
  'tournaments.no_tournaments': 'Aucun tournoi disponible pour le moment.',
  'tournaments.tournaments': 'Tournois',
  'search.followers': 'Abonnés',
  'search.games': 'Jeux',
  'search.lives': 'En Direct',
  'search.search_results': 'Résultats de recherche',
  'search.tournaments': 'Tournois',
  'search.videos': 'Vidéos',
  'tag.games': 'Jeux',
  'tag.live_channels': 'Canaux en Direct',
  'tag.posts': 'Publications',
  'tag.tournaments': 'Tournois',
  'tag.videos': 'Vidéos',
  'layout.play_store': 'Play Store',
  'layout.politique_de_confidentialite': 'Politique de confidentialité',
  'layout.poppins_regular': 'Poppins Regular',
  'layout.something_is_blocking': 'Something is blocking you from accessing our servers.',
  'layout.we_are_experiencing': 'We are experiencing service outages.',
  'legal.address': 'Adresse :',
  // 'legal.cgu': 'Conditions Générales d\'Utilisation', // DUPLICATE - removed (French version at line 345)
  'legal.contact': 'Contact',
  'legal.contentUnavailable': 'Contenu non disponible',
  'legal.contentUnavailableMessage': 'Le contenu demandé n\'est pas disponible pour le moment.',
  'legal.email': 'Email :',
  'legal.errorMessage': 'Impossible de charger le contenu légal. Veuillez réessayer plus tard.',
  'legal.errorTitle': 'Erreur',
  // 'legal.faq': 'Questions Fréquentes', // DUPLICATE - removed (French version at line 346)
  'legal.lastUpdated': 'Dernière mise à jour :',
  'legal.loadingContent': 'Chargement du contenu...',
  // 'legal.mentions': 'Mentions Légales', // DUPLICATE - removed (French version at line 347)
  'legal.phone': 'Téléphone :',
  'legal.privacyPolicy': 'Politique de confidentialité',
  'legal.rgpd': 'Politique de confidentialité',
  'legal.termsOfService': 'Conditions d\'utilisation',
  'legal.version': 'Version :',
  'mentionslegales.mentions_legales': 'Mentions Légales',
  'misc.beta': 'Bêta',
  'misc.comingSoon': 'Prochainement',
  'misc.new': 'Nouveau',
  'misc.recommended': 'Recommandé',
  'misc.showLess': 'Afficher moins',
  'misc.showMore': 'Afficher plus',
  'misc.trending': 'Tendances',
  'misc.viewAll': 'Voir tout',
  'modals.copy_and_paste': 'Copy and paste these settings into your streaming software or see',
  'modals.get_started': 'Get started',
  'modals.if_you_would': 'If you would like to subscribe to our mailing service to recive our latest news.',
  'modals.in_a_live': 'In a live stream, video, or clip',
  'modals.live_stream_setup': 'Live Stream Setup',
  'modals.poppins_regular': 'Poppins Regular',
  'modals.select_a_game': 'Select a game',
  'modals.stream_title': 'Stream title',
  'modals.title_is_required': 'Title is required!',
  'modals.you_need_to': 'You need to report with reason!',
  'modals.you_reported': 'You reported',
  'myevents.create_your_first': 'Créez votre premier événement',
  'myevents.discover_and_join': 'Découvrez et rejoignez des événements passionnants dans votre région !',
  'myevents.failed_to_load': 'Impossible de charger vos événements',
  'myevents.failed_to_publish': 'Impossible de publier l’événement',
  'myevents.loading_your_events': 'Chargement de vos événements...',
  // 'myevents.no_events_created': 'No events created yet', // DUPLICATE - removed (French version at line 368)
  // 'myevents.no_events_joined': 'No events joined yet', // DUPLICATE - removed (French version at line 369)
  'myevents.please_login_to': 'Veuillez vous connecter pour voir vos événements',
  'myevents.start_organizing_your': 'Commencez à organiser votre premier événement et rassemblez les gens !',
  // 'mytournaments.my_tournaments': 'My tournaments', // DUPLICATE - removed (French version at line 388)
  'nav.buyGCoins': 'Acheter des G-Coins',
  'nav.clickToViewTransactions': 'Cliquez pour voir les transactions',
  'nav.createEvent': 'Créer un Événement',
  'nav.createTournament': 'Créer un Tournoi',
  'nav.events': 'Événements',
  'nav.followingChannels': 'Abonnements',
  'nav.goLive': 'Passer en Direct',
  'nav.home': 'Accueil',
  'nav.howToStream': 'Comment Streamer',
  'nav.myEvents': 'Mes Événements',
  'nav.myTournaments': 'Mes Tournois',
  'nav.notifications': 'Notifications',
  'nav.profile': 'Profil',
  'nav.recommended_channels': 'Canaux recommandés',
  'nav.search': 'Rechercher',
  'nav.settings': 'Paramètres',
  'nav.streams': 'Streams',
  'nav.tournaments': 'Tournois',
  'newpassword.confirm_password_is': 'Confirm password is deffirent',
  'newpassword.you_better_enter': 'You better enter 8 characters longer',
  'notfound.404_not_found': '404 Not Found',
  'notification.markAllRead': 'Tout marquer comme lu',
  'notification.message': 'Nouveau message',
  'notification.newFollower': 'Nouveau follower',
  'notification.noNotifications': 'Aucune notification',
  'notification.tournamentStart': 'Le tournoi commence',
  'notification.tournamentUpdate': 'Mise à jour du tournoi',
  'notificationpage.carla_saris': 'Carla Saris',
  'notificationpage.etiam_id_in': 'Etiam id in dolor cras viverra diam, porta tigdgsfsdgsdbsdbsfb...',
  'notificationpage.poppins_regular': 'Poppins Regular',
  'notificationpage.you_have_no': 'You have no Notifications',
  'participants.last_name': 'Last name',
  'participants.no_participants': 'No Participants',
  'participants.player_approved': 'Player approved!',
  'participants.player_deleted': 'Player deleted!',
  'participants.ptserif_regular': 'PTSerif Regular',
  'participants.you_will_not': 'You will not be able to recover the deleted players.',
  'profile.about': 'À propos',
  'profile.all_videos': 'Toutes les Vidéos',
  'profile.avatar': 'Avatar',
  'profile.avatar_upload_failed': 'Échec du téléchargement de l\'avatar',
  'profile.banner': 'Bannière',
  'profile.banner_upload_failed': 'Échec du téléchargement de la bannière',
  'profile.best_clips': 'Meilleurs Clips',
  'profile.bio': 'Biographie',
  'profile.change_avatar': 'Changer l\'Avatar',
  'profile.change_banner': 'Changer la Bannière',
  'profile.donate': 'Faire un Don',
  'profile.edit': 'Modifier le Profil',
  'profile.error_loading_more': 'Erreur lors du chargement de plus de replays:',
  'profile.error_loading_replays': 'Erreur lors du chargement des replays:',
  'profile.failed_to_load': 'Échec du chargement de plus de replays',
  'profile.followers': 'Abonnés',
  'profile.followers_title': 'Abonnés',
  'profile.following': 'Abonnements',
  'profile.fullname': 'Nom Complet',
  'profile.iframe_demo': 'Démo Iframe',
  'profile.load_more': 'Charger Plus',
  'profile.loading': 'Chargement...',
  'profile.loading_profile': 'Chargement du profil...',
  'profile.loading_replays': 'Chargement des replays...',
  'profile.my_videos': 'Mes Vidéos',
  'profile.no_followers': 'Aucun abonné',
  'profile.no_recordings_yet': 'Aucun enregistrement pour le moment',
  'profile.past_streams': 'Streams Passés',
  'profile.profile_picture_updated': 'Photo de profil mise à jour avec succès!',
  'profile.public_profiles_are': 'Les profils publics ne sont pas encore disponibles.',
  'profile.recent_added': 'Ajoutés Récemment',
  'profile.related_channels': 'Chaînes Associées',
  'profile.remove': 'Retirer',
  'profile.report': 'Signaler',
  'profile.start_streaming_message': 'Commencez à streamer pour sauvegarder automatiquement vos replays!',
  'profile.uploading': 'Téléchargement...',
  'profile.videos': 'Vidéos',
  'replayplayer.error_loading_replay': 'Error loading replay:',
  'replayplayer.error_loading_video': 'Error loading video. Please try downloading it instead.',
  'replayplayer.failed_to_load': 'Failed to load replay',
  'replayplayer.loading_replay': 'Loading replay...',
  'replayplayer.replay_not_found': 'Replay not found',
  'replayplayer.videojs_error': 'Video.js error:',
  'replayplayer.your_browser_does': 'Your browser does not support FLV playback. Please use a modern browser or download the video.',
  'report.description': 'Description',
  'report.reason': 'Raison',
  'report.submit': 'Envoyer le signalement',
  'report.success': 'Signalement envoyé',
  'report.title': 'Signaler',
  'resetpassword.forgot_your_password': 'Forgot your password?',
  'resetpassword.please_use_your': 'Please use your email you use to login to Core Arena',
  'search.noResults': 'Aucun résultat trouvé',
  'search.placeholder': 'Rechercher des jeux, des streamers, des tournois...',
  'search.searching': 'Recherche en cours...',
  'settings.a_key_is': 'Une clé est enregistrée — laisser vide pour conserver; entrer pour remplacer.',
  'settings.account': 'Compte',
  'settings.add_your_paypalme': 'Ajoutez votre lien PayPal.me pour recevoir des dons',
  'settings.appearance': 'Apparence',
  'settings.change_password': 'Changer le mot de passe',
  'settings.change_profile_picture': 'Changer la photo de profil',
  'settings.channel_settings': 'Paramètres de la chaîne',
  'settings.channel_settings_are': 'Les paramètres de la chaîne sont enregistrés',
  'settings.confirm_password': 'Confirmer le mot de passe',
  'settings.deleteAccount': 'Supprimer le compte',
  'settings.edit_profile': 'Modifier le profil',
  'settings.enable': 'Activer',
  'settings.enable_multistreaming': 'Activer la multi-diffusion',
  'settings.enter_your_email': 'Entrez votre email...',
  'settings.enter_your_first': 'Entrez votre prénom...',
  'settings.enter_your_last': 'Entrez votre nom...',
  'settings.enter_your_username': 'Entrez votre nom d\'utilisateur...',
  'settings.facebook': 'Facebook',
  'settings.failed_to_save': 'Échec de l\'enregistrement de la configuration',
  'settings.failed_to_upload': 'Échec du téléchargement de l\'avatar',
  'settings.first_name': 'Prénom',
  'settings.forgot_password': 'Mot de passe oublié?',
  'settings.instagram': 'Instagram',
  'settings.keep_streaming_to': 'Continuez à streamer sur notre serveur RTMP comme d\'habitude. En direct, nous rediffusons vers les plateformes activées.',
  'settings.language': 'Langue',
  'settings.last_name': 'Nom',
  'settings.multistreaming': 'Multi-diffusion',
  'settings.new_password': 'Nouveau mot de passe',
  'settings.notifications': 'Notifications',
  'settings.old_password': 'Ancien mot de passe',
  'settings.paypal': 'PayPal',
  'settings.privacy': 'Confidentialité',
  'settings.profile': 'Profil',
  'settings.profile_settings': 'Paramètres du profil',
  'settings.save': 'Enregistrer',
  'settings.saved': 'Enregistré',
  'settings.title': 'Paramètres',
  'settings.twitch': 'Twitch',
  'settings.twitter': 'Twitter',
  'settings.updateEmail': 'Mettre à jour l\'email',
  'settings.updatePassword': 'Mettre à jour le mot de passe',
  'settings.updateUsername': 'Mettre à jour le nom d\'utilisateur',
  'settings.username': 'Nom d\'utilisateur',
  'settings.website': 'Site web',
  'settings.you_have_to': 'Vous devez entrer uniquement votre nom d\'utilisateur Twitter',
  'settings.your_biographie': 'Votre biographie',
  'settings.your_facebooke_url': 'URL de votre Facebook',
  'settings.your_instagram_url': 'URL de votre Instagram',
  'settings.your_paypalme_url': 'Votre URL Paypal.me',
  'settings.your_twitter_url': 'URL de votre Twitter',
  'settings.your_website_url': 'URL de votre site web',
  'settings.your_youtube_channel': 'URL de votre chaîne Youtube',
  'settings.youtube': 'YouTube',
  'stream.aucun_stream_en': 'Aucun stream en cours',
  'stream.aucune_donnee_recue': 'Aucune donnée reçue du serveur',
  'stream.ce_streamer_nest': 'Ce streamer n\'est pas en direct',
  'stream.chat': 'Chat',
  'stream.delai_d': 'Délai d',
  'stream.details': 'Détails',
  'stream.erreur_lors_du': 'Erreur lors du chargement du stream',
  'stream.erreur_serveur_veuillez': 'Erreur serveur, veuillez réessayer plus tard',
  'stream.follow': 'Suivre',
  'stream.impossible_de_se': 'Impossible de se connecter au serveur',
  'stream.le_stream_devrait': 'Le stream devrait apparaître bientôt',
  'stream.live': 'En Direct',
  'stream.network_error': 'Erreur réseau',
  'stream.no_stream_live': 'Aucun stream en direct',
  'stream.offline': 'Hors Ligne',
  'stream.preview': 'Aperçu',
  'stream.session_expiree_veuillez': 'Session expirée, veuillez vous reconnecter',
  'stream.settings': 'Paramètres du Stream',
  'stream.startStreaming': 'Commencer à Streamer',
  'stream.stopStreaming': 'Arrêter le Stream',
  'stream.stream_en_cours': 'Stream en cours de chargement...',
  'stream.stream_may_have': 'Le stream a peut-être pris fin',
  'stream.streamKey': 'Clé de Stream',
  'stream.unfollow': 'Ne plus suivre',
  'stream.veuillez_patienter': 'Veuillez patienter',
  'stream.viewers': 'Spectateurs',
  'streamerdashboard copy.aucun_stream_en': 'Aucun stream en cours',
  'streamerdashboard copy.cle_de_stream': 'Clé de stream régénérée avec succès',
  'streamerdashboard copy.copie_dans_le': 'Copié dans le presse-papiers',
  'streamerdashboard copy.cout': 'Coût',
  'streamerdashboard copy.erreur_lors_de': 'Erreur lors de la régénération:',
  'streamerdashboard copy.gerez_votre_stream': 'Gérez votre stream et configurez OBS',
  'streamerdashboard copy.impossible_de_recuperer': 'Impossible de récupérer la clé de stream',
  'streamerdashboard copy.impossible_de_regenerer': 'Impossible de régénérer la clé de stream',
  'streamerdashboard copy.largeur_300_hauteur': 'Largeur: 300, Hauteur: 400',
  'streamerdashboard copy.parametres_stream_service': 'Paramètres → Stream → Service: Custom',
  'streamerdashboard copy.resolution_1920x1080': 'Résolution: 1920x1080',
  'streamerdashboard copy.scalabilite': 'Scalabilité',
  'streamerdashboard copy.source_de_navigateur': 'Source de navigateur',
  'streamerdashboard copy.sources_source_de': 'Sources → + → Source de navigateur',
  'streamerdashboard copy.temps_de_stream': 'Temps de stream',
  'streamerdashboard copy.temps_reel': 'Temps réel',
  'streamerdashboard copy.url_complete_': 'URL complète :',
  'streamerdashboard copy.url_complete_button': 'URL complète',
  'streamerdashboard copy.url_du_widget': 'URL du widget :',
  'streamerdashboard copy.votre_cle_de': 'Votre clé de stream :',
  'streamerdashboard copy.vues_totales': 'Vues totales',
  'streamerdashboard.aucun_stream_en': 'Aucun stream en cours',
  'streamerdashboard.cle_de_stream': 'Clé de stream régénérée avec succès',
  'streamerdashboard.copie_dans_le': 'Copié dans le presse-papiers',
  'streamerdashboard.cout': 'Coût',
  'streamerdashboard.delai_d': 'Délai d',
  'streamerdashboard.erreur_lors_de': 'Erreur lors de la vérification du statut:',
  'streamerdashboard.erreur_serveur_veuillez': 'Erreur serveur, veuillez réessayer plus tard',
  'streamerdashboard.gerez_votre_stream': 'Gérez votre stream et configurez OBS',
  'streamerdashboard.impossible_de_recuperer': 'Impossible de récupérer la clé de stream',
  'streamerdashboard.impossible_de_regenerer': 'Impossible de régénérer la clé de stream',
  'streamerdashboard.largeur_300_hauteur': 'Largeur: 300, Hauteur: 400',
  'streamerdashboard.parametres_stream_service': 'Paramètres → Stream → Service: Custom',
  'streamerdashboard.resolution_1920x1080': 'Résolution: 1920x1080',
  'streamerdashboard.scalabilite': 'Scalabilité',
  'streamerdashboard.session_expiree_veuillez': 'Session expirée, veuillez vous reconnecter',
  'streamerdashboard.source_de_navigateur': 'Source de navigateur',
  'streamerdashboard.sources_source_de': 'Sources → + → Source de navigateur',
  'streamerdashboard.temps_de_stream': 'Temps de stream',
  'streamerdashboard.temps_reel': 'Temps réel',
  'streamerdashboard.url_complete_': 'URL complète :',
  'streamerdashboard.url_complete_button': 'URL complète',
  'streamerdashboard.url_du_widget': 'URL du widget :',
  'streamerdashboard.votre_cle_de': 'Votre clé de stream :',
  'streamerdashboard.vues_totales': 'Vues totales',
  'success.created': 'Créé avec succès',
  'success.deleted': 'Supprimé avec succès',
  'success.saved': 'Enregistré avec succès',
  'success.sent': 'Envoyé avec succès',
  'success.updated': 'Mis à jour avec succès',
  'termsandconditions.changes_to_our': 'Changes To Our Terms & Conditions',
  'termsandconditions.definitions_and_key': 'Definitions and key terms',
  'termsandconditions.intellectual_property': 'Intellectual Property',
  'termsandconditions.modifications_to_our': 'Modifications to Our website/app',
  'termsandconditions.our_terms_conditions': 'Our Terms & Conditions',
  'termsandconditions.return_and_refund': 'Return and Refund Policy',
  'termsandconditions.third_party_services': 'Third- Party Services',
  'termsandconditions.thirdparty_services': 'Third-Party Services',
  'termsandconditions.updates_to_our': 'Updates to Our Terms',
  'termsandconditions.you_agree_not': 'You agree not to, and you will not permit others to:',
  'termsandconditions.your_consent': 'Your Consent',
  'termsandconditions.your_suggestions': 'Your Suggestions',
  'test_redux.test_redux': 'Test Redux',
  'tournament.archive': 'Archive',
  'tournament.bracket': 'Arbre',
  'tournament.create': 'Créer un Tournoi',
  'tournament.dashboard': 'Tableau de bord',
  'tournament.date': 'Date',
  'tournament.details': 'Détails',
  'tournament.game': 'Jeu',
  'tournament.join': 'Rejoindre',
  'tournament.leave': 'Quitter',
  'tournament.myTournaments': 'Mes Tournois',
  'tournament.participants': 'Participants',
  'tournament.prizes': 'Prix',
  'tournament.rules': 'Règles',
  'tournament.settings': 'Paramètres',
  'tournament.start': 'Démarrer',
  'tournament.status': 'Statut',
  'tournament.title': 'Tournois',
  'tournamentdashboard.error_starting_tournament': 'Error starting tournament',
  'tournamentdashboard.tournament_started': 'Tournament started',
  'tournamentdetails.brackets_will_be': 'Les brackets seront disponibles une fois le tournoi démarré',
  'tournaments.aucun_tournoi_disponible': 'Aucun tournoi disponible pour le moment.',
  'tournaments.chargement_des_tournois': 'Chargement des tournois...',
  'tournaments.erreur_lors_du': 'Erreur lors du chargement des tournois',
  'tournamentsettings.add_some_rules': 'Add some rules',
  'tournamentsettings.double_elimination': 'Double Elimination',
  'tournamentsettings.enter_your_tournamet': 'Enter your tournamet name...',
  'tournamentsettings.poppins_regular': 'Poppins Regular',
  'tournamentsettings.round_robin': 'Round Robin',
  'tournamentsettings.single_elimination': 'Single Elimination',
  'tournamentsettings.tournament_settings': 'Tournament Settings',
  'tournamentsettings.tournamet_name_': 'Tournamet name *',
  'tournamentsettings.upload_failed': 'Upload failed',
  'tournamentsettings.write_a_description': 'Write a description...',
  'videopage.poppins_regular': 'Poppins Regular',

  // Participants page
  'participants.title': 'Participants',
  'participants.approved': 'Approuvé',
  'participants.pending': 'En attente',
  'participants.first_name': 'Prénom',
  // 'participants.last_name': 'Nom', // DUPLICATE - removed (English version at line 487)
  'participants.username': 'Nom d\'utilisateur',
  'participants.email': 'Email',
  'participants.rank': 'Rang',
  'participants.action': 'Action',
  'participants.approve': 'Approuver',
  'participants.delete': 'Supprimer',
  // 'participants.no_participants': 'Aucun participant', // DUPLICATE - removed (English version at line 488)
  // 'participants.player_approved': 'Joueur approuvé !', // DUPLICATE - removed (English version at line 489)
  // 'participants.player_deleted': 'Joueur supprimé !', // DUPLICATE - removed (English version at line 490)
  'participants.delete_player_confirm': 'Supprimer le joueur {username} !',
  'participants.delete_warning': 'Vous ne pourrez pas récupérer les joueurs supprimés.',
  'participants.yes_delete': 'Oui, supprimer !',

  // Notifications page
  'notifications.title': 'Notifications',
  'notifications.mark_all_read': 'Tout marquer comme lu',
  'notifications.started_following': 'a commencé à vous suivre.',
  'notifications.no_notifications': 'Vous n\'avez aucune notification',
  'notifications.empty_alt': 'Notifications vides',

  // Replay Player page
  'replay.failed_to_load': 'Échec du chargement de la rediffusion',
  'replay.error_loading_refresh': 'Erreur de chargement de la vidéo. Veuillez actualiser la page ou télécharger la rediffusion.',
  'replay.browser_not_supported': 'Votre navigateur ne prend pas en charge la lecture FLV. Veuillez utiliser un navigateur moderne ou télécharger la vidéo.',
  'replay.error_loading_download': 'Erreur de chargement de la vidéo. Veuillez essayer de la télécharger à la place.',
  'replay.loading': 'Chargement de la rediffusion...',
  'replay.not_found': 'Rediffusion introuvable',
  'replay.go_home': 'Retour à l\'accueil',
  'replay.views': 'vues',
  'replay.duration': 'Durée',
  'replay.size': 'Taille',
  'replay.game': 'Jeu',
  'replay.download': 'Télécharger la rediffusion',

  // Tournament Dashboard page
  'tournamentdashboard.setup': 'Configuration',
  'tournamentdashboard.pending': 'En attente',
  'tournamentdashboard.running': 'En cours',
  'tournamentdashboard.approved': 'Approuvé',
  // 'tournamentdashboard.tournament_started': 'Tournoi commencé', // DUPLICATE - removed (English version at line 707)
  'tournamentdashboard.error_starting': 'Erreur lors du démarrage du tournoi',
  'tournamentdashboard.account': 'Compte',
  'tournamentdashboard.overview': 'Aperçu',
  'tournamentdashboard.start': 'Démarrer',
  'tournamentdashboard.started': 'Démarré',
  'tournamentdashboard.preview': 'Aperçu',
  'tournamentdashboard.participants': 'Participants',

  // G-Coins / Wallet Transactions
  'transactions.title': 'Mes G-Coins',
  'transactions.subtitle': 'Historique de vos transactions G-Coins',
  'transactions.backToStore': 'Retour à la boutique',
  'transactions.payouts': 'Reversements',
  'transactions.currentBalance': 'Solde actuel',
  'transactions.totalCredits': 'Total crédités',
  'transactions.totalDebits': 'Total dépensés',
  'transactions.totalTransactions': 'Transactions',
  'transactions.history': 'Historique',
  'transactions.all': 'Tout',
  'transactions.credits': 'Crédits',
  'transactions.debits': 'Débits',
  'transactions.noTransactions': 'Aucune transaction pour le moment',
  'transactions.noFilteredTransactions': 'Aucune transaction de ce type',
  'transactions.buyGCoins': 'Acheter des G-Coins',
  'transactions.creditDescription': 'Crédit G-Coins',
  'transactions.debitDescription': 'Débit G-Coins',
  'transactions.balanceAfter': 'Solde',
  'transactions.loginRequired': 'Veuillez vous connecter pour voir vos transactions',
  'transactions.errorLoading': 'Impossible de charger les transactions',

  // Common
  'common.copy': 'Copier',

  // Payments (Stripe)
  'payments.verifyingPayment': 'Vérification du paiement...',
  'payments.verificationInProgressTitle': 'Vérification en cours...',
  'payments.refresh': 'Rafraîchir',
  'payments.backHome': 'Retour à l\'accueil',
  'payments.successTitle': 'Paiement réussi !',
  'payments.successMessage': 'Votre achat a été traité avec succès. Les G-Coins ont été ajoutés à votre wallet.',
  'payments.amountPaid': 'Montant payé',
  'payments.packPurchased': 'Pack acheté',
  'payments.date': 'Date',
  'payments.transactionId': 'Transaction ID',
  'payments.confirmationEmailSent': 'Un email de confirmation a été envoyé à votre adresse email.',
  'payments.viewWallet': 'Voir mon wallet',
  'payments.returnToEvent': 'Retourner à l’événement',
  'payments.missingSessionId': 'Session ID manquant',
  'payments.processing': 'Le paiement est en cours de traitement...',
  'payments.errorVerifying': 'Erreur lors de la vérification du paiement',
  'payments.cancelTitle': 'Paiement annulé',
  'payments.cancelMessage': 'Vous avez annulé le processus de paiement. Aucun montant n\'a été débité.',
  'payments.whyBuy': 'Pourquoi acheter des G-Coins ?',
  'payments.featureUnlimitedStreams': 'Créez des streams et événements illimités',
  'payments.featureExclusiveTournaments': 'Participez à des tournois exclusifs',
  'payments.featurePremium': 'Accédez aux fonctionnalités premium',
  'payments.featureSecureStripe': 'Paiement 100% sécurisé par Stripe',
  'payments.securityNoticeLine1': 'Tous les paiements sont sécurisés et cryptés.',
  'payments.securityNoticeLine2': 'Vos informations bancaires ne sont jamais stockées sur nos serveurs.',
  'payments.returnToStore': 'Retourner à la boutique',
  'payments.needHelp': 'Besoin d\'aide ? Contactez notre support à support@corearena.tv',

  // G-Coins Store
  'gcoinStore.title': 'Boutique G-Coins',
  'gcoinStore.subtitle': 'Achetez des G-Coins pour débloquer toutes les fonctionnalités de CoreArena',
  'gcoinStore.errorLoadingPlans': 'Impossible de charger les plans. Veuillez réessayer.',
  'gcoinStore.toastLoadingPlansError': 'Erreur lors du chargement des plans',
  'gcoinStore.loginRequired': 'Veuillez vous connecter pour acheter des G-Coins',
  'gcoinStore.paymentInitFailed': 'Échec de l\'initialisation du paiement',
  'gcoinStore.startPaymentFailed': 'Impossible de démarrer le paiement',
  'gcoinStore.loading': 'Chargement...',
  'gcoinStore.buy': 'Acheter',
  'gcoinStore.packOf': 'Pack de',
  'gcoinStore.bonus': 'bonus',
  'gcoinStore.aboutTitle': 'À propos des G-Coins',
  'gcoinStore.aboutIntro': 'Les G-Coins sont la monnaie virtuelle de CoreArena. Utilisez-les pour :',
  'gcoinStore.aboutItemStreams': 'Créer des streams et événements',
  'gcoinStore.aboutItemTickets': 'Acheter des tickets pour des événements',
  'gcoinStore.aboutItemTournaments': 'Participer à des tournois',
  'gcoinStore.aboutItemPremium': 'Accéder à des fonctionnalités premium',
  'gcoinStore.sslSecurePayment': 'Paiement sécurisé SSL',
  'gcoinStore.moneyBackGuarantee': 'Remboursement garanti',

  // Payouts (Reversements)
  'payouts.title': 'Reversements',
  'payouts.loginRequired': 'Veuillez vous connecter pour demander un reversement.',
  'payouts.back': 'Retour',
  'payouts.subtitle': 'Demandez un reversement de vos revenus (tickets, dons, etc.).',
  'payouts.loadError': 'Erreur lors du chargement des reversements',
  'payouts.bankMissingFields': 'Veuillez remplir le nom du bénéficiaire et l’IBAN',
  'payouts.bankSaved': 'Informations bancaires enregistrées',
  'payouts.bankSaveError': 'Erreur lors de l’enregistrement',
  'payouts.invalidAmount': 'Montant invalide',
  'payouts.requestSent': 'Demande de reversement envoyée',
  'payouts.requestError': 'Erreur lors de la demande',
  'payouts.balance': 'Solde',
  'payouts.withdrawableBalance': 'Solde retirable',
  'payouts.available': 'Disponible',
  'payouts.revenueCount': 'Transactions',
  'payouts.minimum': 'Minimum',
  'payouts.platformFee': 'Frais plateforme',
  'payouts.bankInfo': 'Informations bancaires',
  'payouts.note': 'Note',
  'payouts.ibanNote': 'Pour changer l’IBAN, merci de le re-saisir.',
  'payouts.beneficiaryName': 'Nom du bénéficiaire *',
  'payouts.iban': 'IBAN *',
  'payouts.bic': 'BIC / SWIFT',
  'payouts.bank': 'Banque',
  'payouts.country': 'Pays (2 lettres)',
  'payouts.currency': 'Devise',
  'payouts.saving': 'Enregistrement…',
  'payouts.save': 'Enregistrer',
  'payouts.requestPayout': 'Demander un reversement',
  'payouts.amount': 'Montant (GCOIN)',
  'payouts.estimation': 'Estimation',
  'payouts.fees': 'Frais',
  'payouts.net': 'Net',
  'payouts.sending': 'Envoi…',
  'payouts.sendRequest': 'Envoyer la demande',
  'payouts.requestAllInfo': 'La demande gèle toutes vos transactions de revenus non encore incluses dans un reversement.',
  'payouts.noWithdrawable': 'Aucun solde retirable pour le moment.',
  'payouts.belowMin': 'Solde retirable inférieur au minimum requis.',
  'payouts.revenueHistory': 'Mes revenus',
  'payouts.noRevenueYet': 'Aucune transaction de revenu pour le moment.',
  'payouts.included': 'Inclus',
  'payouts.syncRevenue': 'Synchroniser mes revenus',
  'payouts.syncingRevenue': 'Synchronisation…',
  'payouts.syncRevenueDone': 'Revenus synchronisés',
  'payouts.syncRevenueNothing': 'Aucun revenu à synchroniser',
  'payouts.syncRevenueError': 'Erreur lors de la synchronisation',
  'payouts.myRequests': 'Mes demandes',
  'payouts.noneYet': 'Aucune demande pour le moment.',
  'payouts.reference': 'Référence',
  'payouts.grossAmount': 'Montant',
  'payouts.netAmount': 'Net',
  'payouts.status': 'Statut',
  'payouts.date': 'Date',
  'payouts.status.completed': 'Terminé',
  'payouts.status.failed': 'Échoué',
  'payouts.status.rejected': 'Rejeté',
  'payouts.status.approved': 'Approuvé',
  'payouts.status.processing': 'En cours',
  'payouts.status.pending': 'En attente',
  'payouts.approvedAt': 'Approuvé',
  'payouts.processedAt': 'Traitement',
  'payouts.completedAt': 'Terminé',
  'payouts.rejectionReason': 'Raison',

  // Streamer Dashboard (additional UI keys)
  'streamerdashboard.dashboard_title': 'Dashboard Streamer',
  'streamerdashboard.stream_key_title': 'Clé de Stream',
  'streamerdashboard.current_stream_key': 'Clé de stream actuelle',
  'streamerdashboard.stream_key_placeholder': 'Clé de stream',
  'streamerdashboard.regenerate_key': 'Régénérer la clé',
  'streamerdashboard.obs_config': 'Configuration OBS',
  'streamerdashboard.server_rtmp': 'Server RTMP :',
  'streamerdashboard.stream_status_title': 'Statut du Stream',
  'streamerdashboard.live': 'EN DIRECT',
  'streamerdashboard.offline': 'HORS LIGNE',
  'streamerdashboard.stream_preview': 'Aperçu du Stream',
  'streamerdashboard.start_obs_to_see': 'Démarrez votre stream dans OBS pour le voir ici',
  'streamerdashboard.open_stream_page': 'Ouvrir ma page stream',
  'streamerdashboard.delai_d_attente': 'Délai d\'attente dépassé, vérifiez votre connexion',
  'streamerdashboard.stream_key_not_received': 'Clé de stream non reçue',
  'streamerdashboard.config_updated': 'Configuration du stream mise à jour ! Vous pouvez maintenant passer en direct dans OBS.',

  // Stream page (additional errors)
  'stream.timeout': 'Délai d\'attente dépassé, vérifiez votre connexion',

  // Create Event (login gate)
  'createevent.login_required_title': 'Connexion requise',
  'createevent.login_required_message': 'Veuillez vous connecter pour créer un événement.',

  // Event Watch page
  'eventWatch.failedToLoad': 'Impossible de charger l’événement',
  'eventWatch.insufficientBalanceRedirect': 'Solde insuffisant. Redirection vers l’achat de G‑Coins…',
  'eventWatch.accessGranted': 'Accès accordé !',
  'eventWatch.failedToGetAccess': 'Impossible d’obtenir l’accès',
  'eventWatch.eventNotFound': 'Événement introuvable',
  'eventWatch.eventPage': 'Page de l’événement',
  'eventWatch.details': 'Détails',
  'eventWatch.bracket': 'Bracket',
  'eventWatch.premiumContent': 'Contenu premium',
  'eventWatch.needAccess': 'Vous devez avoir un accès pour regarder cet événement.',
  'eventWatch.processing': 'Traitement...',
  'eventWatch.getAccess': 'Obtenir l’accès',
  'eventWatch.livePov': 'POV en direct',
  'eventWatch.noLivePovYet': 'Aucun POV en direct pour le moment.',
  'eventWatch.noPlaybackYet': 'Aucun playback live disponible pour le moment.',
  'eventWatch.openPovPage': 'Ouvrir la page stream',
  'eventWatch.notEnoughGcoins': 'Pas assez de G‑Coins',
  'eventWatch.balance': 'Solde',
  'eventWatch.price': 'Prix',
  'eventWatch.buyGcoins': 'Acheter des G‑Coins',

  // Event Dashboard - Team management clarity
  'eventdashboard.team_delete_help': 'Seules les équipes vides peuvent être supprimées avant le démarrage du tournoi.',
  'eventdashboard.team_delete': 'Supprimer l’équipe',
  'eventdashboard.team_delete_confirm': 'Supprimer l’équipe "{name}" ? Cette action est irréversible.',
  'eventdashboard.team_deleted_success': 'Équipe supprimée',
  'eventdashboard.team_deleted_error': 'Échec de la suppression de l’équipe',
  'eventdashboard.team_delete_not_empty': 'Impossible de supprimer une équipe qui contient des membres',
  'eventdashboard.team_delete_running': 'Le tournoi est en cours',
  'eventdashboard.team_empty_badge': 'Équipe vide',
  'eventdashboard.team_empty_badge_help': 'Cette équipe ne contient aucun membre pour le moment.',
  'eventdashboard.team_empty_can_delete': 'Équipe vide — vous pouvez la supprimer.',
  'eventdashboard.team_delete_running_hint': 'Tournoi en cours — la suppression des équipes est désactivée.',
  'eventdashboard.team_delete_not_empty_hint': 'Retirez tous les membres pour pouvoir supprimer cette équipe.',
  'eventdashboard.team_no_members': 'Aucun membre pour le moment.',
  'eventdashboard.team_full': 'Équipe complète',
  'eventdashboard.select_approved_player': 'Sélectionner un joueur approuvé...',

  // Common (additional)
  'common.actions': 'Actions',
  'common.username': 'Nom d’utilisateur',
  'common.joined': 'Inscrit',
  'common.ban': 'Bannir',
  'common.remove': 'Retirer',
  'common.role': 'Rôle',
  'common.name': 'Nom',
  'common.email': 'Email',
  'common.approve': 'Approuver',
  'common.save_changes': 'Enregistrer les modifications',
  'common.draft': 'Brouillon',
  'common.published': 'Publié',
  'common.active': 'Actif',
  'common.completed': 'Terminé',
  'common.cancelled': 'Annulé',
  'common.updating': 'Mise à jour...',
  'common.ellipsis': '...',
  'common.gcoins': 'G‑Coins',
  'common.free': 'Gratuit',
  'common.manage': 'Gérer',
  'common.publish': 'Publier',
  'common.accept': 'Accepter',
  'common.decline': 'Refuser',
  'common.processing': 'Traitement...',

  // Event Dashboard (general UI)
  'eventdashboard.tab_overview': 'Aperçu',
  'eventdashboard.organizer': 'Organisateur',
  'eventdashboard.you': 'Vous',
  'eventdashboard.category': 'Catégorie',
  'eventdashboard.status': 'Statut',
  'eventdashboard.settings': 'Paramètres',
  'eventdashboard.spectators': 'Spectateurs',
  'eventdashboard.viewers': 'Spectateurs',
  'eventdashboard.attendees': 'Participants',
  'eventdashboard.players_streamers': 'Joueurs/Streamers',
  'eventdashboard.bracket': 'Bracket',
  'eventdashboard.stream_control': 'Contrôle du stream',
  'eventdashboard.stream_status': 'Statut du stream',
  'eventdashboard.streamers_players': 'Streamers (Joueurs)',
  'eventdashboard.streamers_help': 'Joueurs invités pouvant participer et streamer leur POV',
  'eventdashboard.no_streamers_invited_yet': 'Aucun streamer invité pour le moment',
  'eventdashboard.invitation': 'Invitation',
  'eventdashboard.invited': 'Invité le',
  'eventdashboard.event_details': 'Détails de l’événement',
  'eventdashboard.event_type': 'Type d’événement',
  'eventdashboard.visibility': 'Visibilité',
  'eventdashboard.public_event': '🌍 Événement public',
  'eventdashboard.private_event': '🔒 Événement privé',
  'eventdashboard.event_configuration': 'Configuration de l’événement',
  'eventdashboard.chat': 'Chat',
  'eventdashboard.quick_actions': 'Actions rapides',
  'eventdashboard.view_public_page': 'Voir la page publique',
  'eventdashboard.manage_players': 'Gérer les joueurs',
  'eventdashboard.view_spectators': 'Voir les spectateurs',
  'eventdashboard.view_attendees': 'Voir les participants',
  'eventdashboard.view_viewers': 'Voir les spectateurs',
  'eventdashboard.edit_settings': 'Modifier les paramètres',
  'eventdashboard.viewers_ticket_holders': 'Spectateurs (détenteurs de ticket)',
  'eventdashboard.viewers_tournament_help': 'Spectateurs inscrits à l’événement (les joueurs se gèrent dans Joueurs/Streamers et Bracket)',
  'eventdashboard.attendees_workshop_help': 'Participants inscrits à l’atelier',
  'eventdashboard.viewers_stream_help': 'Spectateurs ayant accès au stream',
  'eventdashboard.no_spectators_yet': 'Aucun spectateur pour le moment',
  'eventdashboard.no_attendees_yet': 'Aucun participant pour le moment',
  'eventdashboard.no_viewers_yet': 'Aucun spectateur pour le moment',
  'eventdashboard.free_event': 'Événement gratuit',
  'eventdashboard.gcoins_per_ticket': 'G‑Coins/Ticket',
  'eventdashboard.max_players': 'Max joueurs',
  'eventdashboard.max_capacity': 'Capacité max',
  'eventdashboard.not_authorized_manage': 'Vous n’êtes pas autorisé à gérer cet événement',
  'eventdashboard.failed_to_load_event': 'Impossible de charger l’événement',
  'eventdashboard.event_not_found': 'Événement introuvable',

  // Tournament admin / bracket
  'eventdashboard.tournament_bracket': '🌳 Bracket du tournoi',
  'eventdashboard.tournament_bracket_help': 'Bracket en direct et gestion basique des joueurs pour cet événement de tournoi.',
  'eventdashboard.players_tournament_control': 'Joueurs & contrôle du tournoi',
  'eventdashboard.loading_players': 'Chargement des joueurs...',
  'eventdashboard.teams_entrants': 'Équipes (participants)',
  'eventdashboard.approved_players': 'Joueurs approuvés',
  'eventdashboard.running': 'En cours',
  'eventdashboard.not_started': 'Pas démarré',
  'eventdashboard.format': 'Format',
  'eventdashboard.single_elimination': 'single-elimination',
  'eventdashboard.bracket_settings': 'Paramètres du bracket',
  'eventdashboard.max_players_bracket_help': 'Nombre max de joueurs (taille du bracket). Modifiable uniquement avant le démarrage du tournoi.',
  'eventdashboard.update_max_players': 'Mettre à jour le max joueurs',
  'eventdashboard.reset_tournament_to_change': 'réinitialisez le tournoi pour modifier ceci',
  'eventdashboard.start_tournament': 'Démarrer le tournoi',
  'eventdashboard.sync_players': 'Synchroniser les joueurs',
  'eventdashboard.reset_tournament_button': '🧹 Réinitialiser le tournoi',
  'eventdashboard.teams': 'Équipes',
  'eventdashboard.team_size': 'Taille d’équipe',
  'eventdashboard.one_team_per_player': 'Un joueur ne peut être que dans une seule équipe.',
  'eventdashboard.update_team_size': 'Mettre à jour la taille d’équipe',
  'eventdashboard.disable_teams': 'Désactiver les équipes',
  'eventdashboard.reset_tournament_to_change_team_settings': 'réinitialisez le tournoi pour modifier les paramètres d’équipe',
  'eventdashboard.team_name': 'Nom de l’équipe',
  'eventdashboard.creating': 'Création...',
  'eventdashboard.create_team': 'Créer l’équipe',
  'eventdashboard.no_teams_help': 'Aucune équipe pour le moment. Créez-en une ci-dessus, puis assignez des joueurs approuvés.',
  'eventdashboard.team': 'Équipe',
  'eventdashboard.members': 'Membres',
  'eventdashboard.add_member': 'Ajouter un membre',
  'eventdashboard.teams_disabled': 'Les équipes sont actuellement',
  'eventdashboard.disabled': 'désactivées',
  'eventdashboard.teams_disabled_suffix': 'pour ce tournoi.',
  'eventdashboard.tournament_is': 'Le tournoi est',
  'eventdashboard.active': 'actif',
  'eventdashboard.reset_to_enable_teams': 'Réinitialisez-le pour activer les équipes.',
  'eventdashboard.enable_teams': 'Activer les équipes',
  'eventdashboard.no_players_invite_help': 'Aucun joueur pour le moment. Utilisez l’onglet "Joueurs/Streamers" pour les inviter.',
  'eventdashboard.match_management': 'Gestion des matchs',
  'eventdashboard.no_active_matches': 'Aucun match actif. Le bracket ci-dessus montre la progression du tournoi.',
  'eventdashboard.click_name_set_winner_prefix': 'Cliquez sur le nom d’un',
  'eventdashboard.player': 'joueur',
  'eventdashboard.click_name_set_winner_suffix': 'pour le définir comme vainqueur de ce match.',
  'eventdashboard.match': 'Match',
  'eventdashboard.team_1': 'Équipe 1',
  'eventdashboard.team_2': 'Équipe 2',
  'eventdashboard.player_1': 'Joueur 1',
  'eventdashboard.player_2': 'Joueur 2',
  'eventdashboard.vs': 'vs',
  'eventdashboard.tbd': 'À définir',
  'eventdashboard.dash': '—',
  'eventdashboard.completed': '✅ Terminé',
  'eventdashboard.pending': '⏳ En attente',
  'eventdashboard.no_linked_tournament_help': 'Aucun tournoi lié pour le moment. Republiez l’événement ou contactez le support si cela persiste.',

  // Stream control
  'eventdashboard.stream_control_title': '🎥 Contrôle du stream',
  'eventdashboard.workshop_stream_help': 'En tant qu’organisateur de l’atelier, vous êtes le présentateur principal. Utilisez les contrôles ci-dessous pour gérer votre stream.',
  'eventdashboard.stream_organizer_help': 'En tant qu’organisateur du stream, vous contrôlez la diffusion. Configurez vos paramètres ci-dessous.',
  'eventdashboard.live': '🔴 EN DIRECT',
  'eventdashboard.offline': '⚫ HORS LIGNE',
  'eventdashboard.manage_live_stream': '📺 Gérer le live',
  'eventdashboard.go_live': '🚀 Passer en direct',
  'eventdashboard.stream_configuration': 'Configuration du stream',
  'eventdashboard.restream_help': 'Diffusez simultanément vers vos plateformes configurées (Twitch, YouTube, Facebook)',
  'eventdashboard.auto_replay_help': 'Enregistrez automatiquement et rendez le replay disponible après la fin du stream',
  'eventdashboard.chat_help': 'Contrôlez qui peut participer au chat',
  'eventdashboard.workshop_capacity': 'Capacité de l’atelier',
  'eventdashboard.current_attendees': 'Participants actuels',
  'eventdashboard.workshop_full': 'L’atelier est complet',

  // Settings + tickets
  'eventdashboard.banner_image_updated': 'Image de bannière mise à jour',
  'eventdashboard.upload_failed': 'Échec de l’envoi',
  'eventdashboard.event_settings': 'Paramètres de l’événement',
  'eventdashboard.images': 'Images',
  'eventdashboard.upload_banner_help_prefix': 'Téléversez une',
  'eventdashboard.banner': 'bannière',
  'eventdashboard.upload_banner_help_suffix': 'pour votre tournoi. Elle sera utilisée sur la page de détails et dans les listes.',
  'eventdashboard.banner_image': 'Image de bannière',
  'eventdashboard.event_banner_alt': 'Bannière de l’événement',
  'eventdashboard.event_name': 'Nom de l’événement',
  'eventdashboard.ticket_price_gcoins': 'Prix du ticket (G‑Coins)',
  'eventdashboard.max_participants': 'Participants max',
  'eventdashboard.tickets_access': 'Tickets & accès',
  'eventdashboard.ticket_codes_help': 'Générez des codes de ticket à distribuer à vos spectateurs, sponsors ou partenaires. Chaque code peut être utilisé une seule fois pour accéder à cet événement.',
  'eventdashboard.ticket_price': 'Prix du ticket',
  'eventdashboard.gcoins': 'G‑Coins',
  'eventdashboard.tickets_issued': 'Tickets émis',
  'eventdashboard.used': 'Utilisés',
  'eventdashboard.pending_plain': 'En attente',
  'eventdashboard.generating_codes': 'Génération des codes...',
  'eventdashboard.generate_ticket_codes': 'Générer des codes de ticket',
  'eventdashboard.new_codes_help': 'Nouveaux codes générés (copiez et partagez-les avec vos spectateurs) :',
  'eventdashboard.all_issued_codes': 'Tous les codes émis (persistés) :',
  'eventdashboard.used_upper': 'UTILISÉ',
  'eventdashboard.pending_upper': 'EN ATTENTE',

  // Confirmations + actions
  'eventdashboard.confirm_ban_user': 'Êtes-vous sûr de vouloir bannir cet utilisateur ?',
  'eventdashboard.user_banned_success': 'Utilisateur banni avec succès',
  'eventdashboard.failed_ban_user': 'Échec du bannissement',
  'eventdashboard.confirm_remove_streamer': 'Retirer ce streamer de l’événement ?',
  'eventdashboard.streamer_removed': 'Streamer retiré',
  'eventdashboard.failed_remove_streamer': 'Échec du retrait du streamer',
  'eventdashboard.event_updated_success': 'Événement mis à jour avec succès',
  'eventdashboard.failed_update_event': 'Échec de la mise à jour',
  'eventdashboard.prompt_ticket_codes_qty': 'Combien de codes de ticket voulez-vous générer ?',
  'eventdashboard.invalid_quantity': 'Quantité invalide',
  'eventdashboard.generated': 'Généré',
  'eventdashboard.codes': 'codes',
  'eventdashboard.failed_generate_ticket_codes': 'Échec de la génération des codes',
  'eventdashboard.player_approved': 'Joueur approuvé',
  'eventdashboard.failed_approve_player': 'Échec de l’approbation du joueur',
  'eventdashboard.confirm_remove_player': 'Retirer ce joueur du tournoi ?',
  'eventdashboard.player_removed_from_tournament': 'Joueur retiré du tournoi',
  'eventdashboard.failed_remove_player': 'Échec du retrait du joueur',
  'eventdashboard.tournament_started': 'Tournoi démarré',
  'eventdashboard.failed_start_tournament': 'Échec du démarrage du tournoi',
  'eventdashboard.team_size_min_1': 'La taille d’équipe doit être au moins 1',
  'eventdashboard.teams_enabled': 'Équipes activées',
  'eventdashboard.failed_enable_teams': 'Échec de l’activation des équipes',
  'eventdashboard.team_size_updated': 'Taille d’équipe mise à jour',
  'eventdashboard.failed_update_team_size': 'Échec de la mise à jour de la taille d’équipe',
  'eventdashboard.confirm_disable_teams': 'Désactiver les équipes ? (Vous pourrez les réactiver plus tard. Les équipes existantes resteront en base pour le moment.)',
  'eventdashboard.teams_disabled_success': 'Équipes désactivées',
  'eventdashboard.failed_disable_teams': 'Échec de la désactivation des équipes',
  'eventdashboard.confirm_reset_tournament': 'Réinitialiser le tournoi ? Cela effacera le bracket/les matchs et permettra de reconfigurer les équipes.',
  'eventdashboard.tournament_reset': 'Tournoi réinitialisé',
  'eventdashboard.failed_reset_tournament': 'Échec de la réinitialisation du tournoi',
  'eventdashboard.delete_confirm_tournament': 'Supprimer ce tournoi ? Cette action est irréversible.',
  'eventdashboard.delete_confirm_event': 'Supprimer cet événement ? Cette action est irréversible.',
  'eventdashboard.synced_players_to_tournament': 'Joueurs synchronisés vers le tournoi',
  'eventdashboard.failed_sync_players': 'Échec de la synchronisation des joueurs',
  'eventdashboard.team_created': 'Équipe créée',
  'eventdashboard.failed_create_team': 'Échec de la création de l’équipe',
  'eventdashboard.player_assigned_to_team': 'Joueur assigné à l’équipe',
  'eventdashboard.failed_assign_player': 'Échec de l’assignation du joueur',
  'eventdashboard.member_removed': 'Membre retiré',
  'eventdashboard.failed_remove_member': 'Échec du retrait du membre',
  'eventdashboard.delete_team': 'Supprimer l’équipe',
  'eventdashboard.cannot_undo': 'Cette action est irréversible.',
  'eventdashboard.failed_load_tournament_info': 'Impossible de charger les informations du tournoi',
  'eventdashboard.tournament_active_reset_to_change_max_players': 'Le tournoi est déjà actif. Réinitialisez-le pour modifier le nombre maximum de joueurs.',
  'eventdashboard.max_players_min_2': 'Le nombre maximum de joueurs doit être au moins 2',
  'eventdashboard.max_players_updated': 'Max joueurs mis à jour',
  'eventdashboard.failed_update_max_players': 'Échec de la mise à jour du max joueurs',
  'eventdashboard.winner_set_success': 'Vainqueur défini avec succès',
  'eventdashboard.failed_set_winner': 'Échec lors de la définition du vainqueur',

  // Events page (additional)
  'events.status_coming_soon': 'Bientôt',
  'events.status_pending': 'En attente',
  'events.status_unknown': 'Inconnu',
  'events.watch': 'Regarder',
  'events.details': 'Détails',
  'common.tbd': 'À définir',

  // Tournament Events page
  'tournamentEvents.title': 'Événements Tournois',
  'tournamentEvents.discover': 'Découvrir',
  'tournamentEvents.myEvents': 'Mes tournois',
  'tournamentEvents.allEvents': 'Tous les événements',
  'tournamentEvents.searchPlaceholder': 'Rechercher par nom ou description…',
  'tournamentEvents.noEventsTitle': 'Aucun tournoi',
  'tournamentEvents.noEventsDesc': 'Aucun tournoi ne correspond à vos filtres.',
  'tournamentEvents.pleaseLogin': 'Veuillez vous connecter pour voir vos tournois',
  'tournamentEvents.failedToLoad': 'Impossible de charger les tournois',
  'tournamentEvents.failedToLoadMine': 'Impossible de charger vos tournois',
  'tournamentEvents.bracket': 'Bracket',
  'tournamentEvents.status.live': 'En direct',
  'tournamentEvents.status.comingSoon': 'Bientôt',
  'tournamentEvents.status.pending': 'En attente',
  'tournamentEvents.status.finished': 'Terminé',

  // My Events page (additional)
  'myevents.invitations': 'Invitations',
  'myevents.published_success': 'Événement publié avec succès !',
  'myevents.joined_status_registered': 'Inscrit',
  'myevents.joined_status_live_now': 'En direct',
  'myevents.joined_status_attended': 'Participé',
  'myevents.invitation_status_pending': 'En attente',
  'myevents.invitation_status_accepted': 'Acceptée',
  'myevents.invitation_status_declined': 'Refusée',
  'myevents.invitation_accepted': 'Invitation acceptée',
  'myevents.failed_accept_invitation': 'Échec de l’acceptation de l’invitation',
  'myevents.invitation_declined': 'Invitation refusée',
  'myevents.failed_decline_invitation': 'Échec du refus de l’invitation',
  'myevents.role_player': 'joueur',
  'myevents.view_event': 'Voir l’événement',
};

export default dictionary;
